import { createSlice } from '@reduxjs/toolkit';

export const initialState = {
  data: {
    events: [],
    activeChat: {
      lexBot: null,
      salesForce: null
    }
  }
};

export const slice = createSlice({
  name: 'analytics',
  initialState,
  reducers: {
    setInitialState: (state) => {
      state.data = initialState.data;
    },
    pushEvent: (state, { payload }) => {
      state.data.events = [payload, ...state.data.events];
    },
    setActiveChat: (state, { payload }) => {
      state.data.activeChat = payload;
    }
  }
});

export const { setInitialState, pushEvent, setActiveChat } = slice.actions;

export const selectSlice = (state) => state[slice.name];
export const selectSliceData = (state) => selectSlice(state).data;
export const selectEvents = (state) => selectSliceData(state).events;
export const selectActiveChat = (state) => selectSliceData(state).activeChat;

export default slice.reducer;
